Drupal.behaviors.molecules = {
  attach(context) {
    console.log('Attach pattern listing-row');
  },
};
